module.exports = __webpack_public_path__ + "static/media/03.789f4438.jpg";